export default __webpack_public_path__ + "static/media/ArriveUSA.9764b569.jpeg";